<script setup lang="ts">
import { isArray, isBoolean } from 'lodash';
import { computed, useAttrs } from 'vue';
import type { CheckboxProps } from '../types';

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(defineProps<CheckboxProps>(), {
  mode: 'edit',
  hideDetails: false,
  density: 'compact',
});

const attrs = useAttrs();

const passdownAttrs = computed(() => ({
  ...attrs,
  class: { selected: displayValue.value },
}));

const emits = defineEmits<{
  'update:modelValue': [value: unknown | unknown[]];
}>();

function update(value: unknown | unknown[]) {
  emits('update:modelValue', value);
}

const displayValue = computed(() => {
  if (isArray(props.modelValue)) {
    return props.modelValue.includes(props.value);
  } else if (isBoolean(props.modelValue)) {
    return props.modelValue;
  } else {
    // An unset model must not match an unset `value`.
    return props.value !== undefined && props.modelValue === props.value;
  }
});
</script>

<template>
  <div :class="$attrs.class">
    <template v-if="mode === 'details'">
      <v-checkbox v-bind="{ ...props, ...passdownAttrs }" disabled :modelValue="displayValue" />
    </template>
    <v-checkbox
      v-else
      v-bind="{ ...props, ...passdownAttrs }"
      :error="Boolean(errorMessage)"
      :hint="errorMessage || hint"
      :persistentHint="Boolean(errorMessage) || persistentHint"
      @update:modelValue="update"
    />
  </div>
</template>
